var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-container',{staticClass:"pa-0 container-bottom"},[_c('Card',{attrs:{"class-object":['mr-5']}},[_c('Sp',{staticClass:"text-caption font-weight-regular"},[_vm._v(_vm._s(_vm.text))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }